var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{class:[!_vm.isWx ? 'pc-style' : 'wx-style'],attrs:{"id":"app"}},[(_vm.isWx)?_c('meta',{attrs:{"name":"viewport","content":"width=device-width, initial-scale=1.0, maximum-scale=1.0, user-scalable=no"}}):_vm._e(),_c('router-view')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }